import dateService from '@gem/services/date-service';

import Tasks from 'APP/Tasks';
import { UpdateReason } from 'APP/constants/scroll';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { Schedule } from 'STORE/Groups/Schedule';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';

function updateMessage(group: Group, msg: ChatMessage, date: Date): ChatMessage {
  msg.clientTime = date.getTime();
  msg.serverTime = msg.clientTime;

  Tasks.messaging.updateOldOrFakeMessages({
    messages: [msg],
    groupId: group.id,
  });

  return group.messagesStore.getMessageById(msg.id)!;
}

async function updateScheduledMessage(groupId: string, msg: ChatMessage): Promise<void> {
  try {
    const now = dateService.now().getTime();
    const messageToJson = msg.toJSON();

    await messageModel.updateScheduledMessage({
      groupId,
      messageId: msg.id,
      clientTime: now.toString(),
      delay: (msg.clientTime - now).toString(),
      payload: msg.payload.toJSON(),
      clientId: msg.clientUuid,
      quotedMessageData: messageToJson.quotedMessageData,
    });
  } catch (error) {
    msg.setError(MessageError.Edit);
  }
}

export function editScheduledMessage({
  message,
  date,
}: {
  message: ChatMessage;
  date: Date;
}): boolean {
  const scheduledGroup = Entities.GroupsStore.getGroupById(message.groupId) as Schedule;
  if (!scheduledGroup) {
    return false;
  }

  const group = scheduledGroup.groupId
    ? Entities.GroupsStore.getGroupById(scheduledGroup.groupId)
    : null;

  if (!group) {
    return false;
  }

  if (Entities.GroupsStore.activeGroupId) {
    Tasks.messaging.clearInputPanel(Entities.GroupsStore.activeGroupId);
  }

  const newMsg = updateMessage(scheduledGroup, message, date);
  updateScheduledMessage(group.id, newMsg);
  if (group.isActive) {
    Entities.ChatStore.setScrollChanged(UpdateReason.EditMessage, {
      messageIds: [message.id],
      isAnimated: true,
    });
  }
  return true;
}
